import { useState } from "react";
import { ChevronRight, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Reveal } from "../ui-kit";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Enter your email.");
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list! We'll notify you at launch.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="relative py-24 bg-[#080808] border-y border-white/5 overflow-hidden" data-testid="newsletter-section">
      <div className="absolute inset-0 grid-lines opacity-30" />
      <Reveal className="relative mx-auto max-w-3xl px-5 md:px-8 text-center">
        <div className="mx-auto mb-6 h-14 w-14 flex items-center justify-center border border-orange-500/40 text-orange-500">
          <Mail size={26} />
        </div>
        <h2 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tight text-white">Stay Updated</h2>
        <p className="mt-4 text-lg text-zinc-400">Be the first to know when Sobtrex officially launches.</p>

        <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto" data-testid="newsletter-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            data-testid="newsletter-email"
            className="flex-1 bg-black/60 border border-zinc-800 text-white px-5 py-4 placeholder:text-zinc-600 focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:outline-none transition-colors"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="bg-[#ff5a00] text-black font-display text-sm font-bold uppercase tracking-wide px-8 py-4 hover:bg-[#e04f00] transition-colors flex items-center justify-center gap-1.5 disabled:opacity-60"
          >
            {loading ? "..." : <>Notify Me <ChevronRight size={16} /></>}
          </button>
        </form>
      </Reveal>
    </section>
  );
}
